export const contactInfo = {
    mailTo: "info@lavishhome.co.uk",
    phone: "01704 530630",
    page: "/page/contact",
    facebook: "https://www.facebook.com/LavishHomeLtd",
    instagram: "https://www.instagram.com/lavishhomeinteriorsltd/",
    twitter: "",
    pinterest: "",
    youtube: "",
    linkedin: ""
}

export const contactForm = {
    fields:
    {
        name: {
            required: false,
            showInput: true
        },
        email: {
            required: false,
            showInput: true
        },
        phone: {
            required: false,
            showInput: true
        },
        storeName: {
            required: false,
            showInput: false
        },
        message: {
            required: false,
            showInput: true
        },

    }
}

export const sendAMessage = {
    title: 'Contact',
    subtitle: 'Send Us a Message',
    description: 'Get in touch with us.  Please use the contact form and we will get back to you as soon as possible.',
    callUs: {
        title: 'Call Us',
        subtitle: ' Our friendly and knowledgeable staff will be able to help with any questions you may have.',
    }
}

export const storeLocations = {
    title: 'Store Locations',
    subtitle: 'Lavish Home Interiors are retailers of stunning contemporary furniture, lighting and home accessories based in Southport.',
    where: {
        title: 'WHERE WE OPERATE',
        subtitle: '10-16 Coronation Walk, Southport, PR8 1RE',
        urlMap: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d591.2565837069135!2d-3.011573271434416!3d53.64650259322702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487b12120208b085%3A0x4184f42d0117feef!2sLavish%20Home%20Interiors!5e0!3m2!1sen!2suy!4v1728584964122!5m2!1sen!2suy'
    },
    opening: {
        title: 'Opening Hours',
        subtitle: 'Monday to Saturday 10am until 5pm, Closed on Sunday.'
    }
}

export const  socialMediaMetadataInfo = {    
    urlImageSocial: '',
    urlTwitterImage: '',
}

export const showCaptcha = {
    visible: false,
    sitekey: "2ce7ad9b-d0ba-4b4a-b453-30dcdf4448ba", // (hcaptcha email= info@thewebsystem.com , password =BCEjzWCv_emg4R3)
    language: 'en'
}